module.exports = __webpack_public_path__ + "img/GS_Profile-Teko Mataoe.00399a35.png";